<template>
  <div class="container">
    <div class="clearfix">
      <Form @submit.native.prevent :model="formData" :rules="modalRule" ref="formData" :label-width="80"   class="mytable-titleBox">
        <div class="clearfix">
          <FormItem label="昵称 :" class="mytable-title" prop="username">
            <Input v-model="formData.username" placeholder="请输入昵称,最多6个字" :maxlength="6"></Input>
          </FormItem>
          <FormItem v-if="isAdmin" label="id :" class="mytable-title">
            <Input v-model="userId" readonly="readonly"></Input>
          </FormItem>
          <FormItem label="手机号 :" class="mytable-title">
            <!--<Input v-model="phone" type="textarea" :rows="4" placeholder="请输入以,分割的手机号" />-->
            <Tag v-for="item in phones" :key="item" :name="item" closable @on-close="handleClose2">{{ item }}</Tag>
            <Button icon="ios-add" type="dashed" size="small" @click="handleAdd">添加手机号</Button>
            <!--<Select-->
              <!--ref="select"-->
              <!--multiple-->
              <!--v-model="ids"-->
              <!--filterable-->
              <!--remote-->
              <!--:remote-method="getSearchData"-->
              <!--@on-change="handleSearchChange"-->
              <!--placeholder="先输入,再选择"-->
              <!--:loading="searchLoading">-->
              <!--<Option v-for="(option) in searchList" :value="option.id" :key="option.id">-->
                  <!--<img :src="option.poster" class="author_pic" alt=""> {{ option.username +'(' +option.create_time + ')'}}-->
              <!--</Option>-->
            <!--</Select>-->
          </FormItem>
          <FormItem v-if="isAdmin" label="投中 :" class="mytable-title" prop="basket">
            <Input v-model="formData.basket" placeholder="请输入投中值,最多7个字" :maxlength="7"></Input>
          </FormItem>
          <FormItem label="密码 :" class="mytable-title" prop="password">
            <Input v-model="formData.password"></Input>
          </FormItem>
          <FormItem v-if="isAdmin" label="简介 :" class="mytable-title" prop="summary">
            <Input v-model="formData.summary" class="input294Width" style="width: 400px;" type="textarea" :maxlength="50" placeholder="请输入作者简介,最多50个字"></Input>
          </FormItem>
          <FormItem label="头像" class=" mt24">
            <img v-if="imgSrc" :src="imgSrc" width="88" height="88" class="img-obj">
            <Upload
              ref="upload"
              :on-success="()=>{}"
              :format="['jpg','jpeg','png']"
              :max-size="2048"
              :before-upload="beforeImgUpload"
              type="drag"
              action=""
              style="display: inline-block;width:88px;">
              <div style="width: 88px;height:88px;line-height: 88px;border: 1px dashed #d9d9d9;">
                <Icon type="ios-camera" size="20"></Icon>
              </div>
            </Upload>
          </FormItem>
          <div style="text-align: center">
            <Button type="primary" @click="saveInfor" :loading="saveLoading">保存</Button>
          </div>
        </div>

      </Form>
    </div>

  </div>
</template>

<script>
import * as qiniu from 'qiniu-js'
export default {
  name: 'person',
  data () {
    const validateBasket = (rule, value, callback) => {
      let reg = /\d+/g
      if (value && value.length === 7 && !reg.test(value)) {
        callback(new Error('7个汉字时不能全为中文哦!'))
      } else {
        callback()
      }
    }
    return {
      phone: '',
      phones: [],
      isAdmin: localStorage.getItem('sa') - 0 === 0,
      imgSrc: '',
      saveLoading: false,
      formData: {},
      disabledGroup: {},
      poster: '',
      changeStatus: false,
      userId: '',
      ids: '',
      modalRule: {
        username: [
          { required: true, message: '请输入昵称', trigger: 'blur' }
        ],
        basket: [
          { required: true, message: '请输入投中', trigger: 'blur' },
          { validator: validateBasket, trigger: 'blur' }
        ],
        summary: [
          { required: true, message: '请输入简介', trigger: 'blur' }
        ]
      },
      searchList: [],
      searchLoading: false,
      cacheUserName: '',
      cachePoster: ''
    }
  },
  mounted () {
    this.getInfor()
  },
  methods: {
    handleAdd () {
      if (this.phones.length >= 1 && this.isAdmin) {
        this.$Message.warning('作者只能绑定一个手机号!')
        return
      }
      this.$Modal.confirm({
        render: (h) => {
          return h('Input', {
            props: {
              value: this.phone,
              autofocus: true,
              placeholder: '请输入手机号'
            },
            on: {
              input: (val) => {
                this.phone = val
              }
            }
          })
        },
        onOk: () => {
          this.phones.push(this.phone)
          this.phone = ''
        }
      })
    },
    handleClose2 (event, name) {
      const index = this.phones.indexOf(name)
      this.phones.splice(index, 1)
    },
    getSearchData (val) {
      this.$api.queryUser({ username: val, page_num: 1, page_size: 5 }).then(res => {
        if (res.code === 0) {
          this.searchList = res.data.list
        } else {
          this.$Message.error(res.msg)
        }
      })
    },
    handleSearchChange (e) {
      this.searchList = []
      if (this.ids.length >= 2 && this.isAdmin) {
        this.$Message.warning('作者只能绑定一个微信!')
      }
    },
    getInfor (params) {
      this.$api.getMyself({}).then(res => {
        if (res.code === 0) {
          this.formData = Object.assign({}, res.data)
          this.cachePoster = this.poster = this.imgSrc = res.data.poster
          this.cacheUserName = res.data.username
          this.userId = res.data.id
          this.searchList = res.data.ma_list
          this.phones = res.data.ma_list ? res.data.ma_list : []
          // this.$nextTick(() => {
          //   this.ids = res.data.ma_list.map(item => {
          //     return item.id
          //   })
          // })
        } else {
          this.$Message.error(res.msg)
        }
      })
    },
    // 保存信息
    saveInfor () {
      let param = {
        poster: this.poster,
        username: this.formData.username,
        basket: this.formData.basket,
        summary: this.formData.summary,
        password: this.formData.password,
        phones: this.phones.join(',')
        // ids: this.ids.join(',')
      }
      if (this.ids.length >= 2 && this.isAdmin) {
        this.$Message.error('作者只能绑定一个微信哦')
        return
      }
      this.$refs.formData.validate(valid => {
        if (valid) {
          this.saveLoading = true
          this.$api.chgMyself(param).then(res => {
            if (res.code === 0) {
              this.$Message.success(res.msg)
              if (this.cachePoster !== this.poster || this.cacheUserName !== this.formData.username) {
                window.location.reload()
              }
            } else {
              this.$Message.error(res.msg)
            }
            this.saveLoading = false
          })
        }
      })
    },
    // 图片上传
    beforeImgUpload (file) {
      let that = this
      // 从后台获取token和key
      this.$api.getQiToken({}).then(res => {
        if (res.code === 0) {
          let key = res.data.key
          let token = res.data.QiNiuToken
          let config = {
            useCdnDomain: true,
            region: null
          }
          let putExtra = {
            fname: '',
            params: {},
            mimeType: null
          }
          let observable = qiniu.upload(file, key, token, putExtra, config)
          observable.subscribe({
            error: function (err) {
              this.$Message.success(err)
            },
            complete: function (res) {
              that.poster = res.key
              that.$api.getImgPath({ key: res.key }).then(res => {
                if (res.code === 0) {
                  that.imgSrc = res.msg
                }
              })
            }
          })
        } else {
          this.$Message.error(res.msg)
        }
      })
      return false
    }

  }
}
</script>

<style scoped>
  /deep/ .ivu-form-item-content{
    width: 400px;
  }
  /deep/ .ivu-upload-drag{
    background: transparent;
  }
  .mytable-titleBox{
    width: 500px;
    margin: 0 auto;
  }
  .author_pic{
    width: 20px;
    height: 20px;
    border-radius: 100%;
    vertical-align: middle;
    margin-right: 10px;
  }
</style>
